import React from 'react';
import PropTypes from 'prop-types';

const VipAccountManagerLink = React.lazy(() =>
    import(/* webpackChunkName: "VipAccountManagerLink" */ './VipAccountManagerLink')
);

export function VipAccountManagerLinkLazy({
    isClient,
    hasRootPendingRefetch,
    hasUserId,
    userIds,
    viewer,
}) {
    return (
        isClient && (
            <React.Suspense fallback="">
                <VipAccountManagerLink
                    hasRootPendingRefetch={hasRootPendingRefetch}
                    hasUserId={hasUserId}
                    userIds={userIds}
                    viewer={viewer}
                />
            </React.Suspense>
        )
    );
}

VipAccountManagerLinkLazy.propTypes = {
    isClient: PropTypes.bool,
    hasRootPendingRefetch: PropTypes.bool,
    hasUserId: PropTypes.bool,
    userIds: PropTypes.array,
    viewer: PropTypes.object,
};
